import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-8 py-20 md:py-28 flex flex-col items-center justify-center text-center">
      <span className="w-20 h-20 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center mb-6">
        <i className="ri-movie-2-line text-4xl" />
      </span>
      <h1 className="font-heading text-5xl md:text-7xl font-black text-primary-200 select-none">
        404
      </h1>
      <h2 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
        这个页面还没有内容
      </h2>
      <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
      <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-md">
        你访问的页面不存在或已被移动。可以回到首页，或前往影视分类继续浏览精彩内容。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-semibold hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category"
          className="px-5 py-2.5 rounded-md border border-background-300 bg-background-50 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}